import React from "react";
import { Button } from "antd";
import Header from "../components/Header";
import LeftColumn from "../components/LeftColumn";
import Content from "../components/Content";
import "./Product.css";
import { useLocation } from "react-router-dom";
import ProductCard from "../components/ProductCard";

const Product = () => {
  let { state: item } = useLocation();

  return (
    <>
      <div className="page-bg">
        <div className="container">
          <Header />
          <div className="content__wrapper">
            <LeftColumn />
            <ProductCard
              name={item.name}
              about={item.about}
              price={item.price}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
